import { useEffect, useState } from "react";
import axios from "axios";
import settings from "../../../components/getrequest";
import { format } from 'date-fns';
import { normalizeCharityPlans } from '../../../plans'

function Billings() {
  const [billingHistory, setBillingHistory] = useState([]);
  const [isProcessing, setIsProcessing] = useState()
  const [card, setCard] = useState([])
  let urlbase = process.env.REACT_APP_BASE;
  const [bill, setBill] = useState();
  const [billing, setBilling] = useState([]);
  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [holder, setHolder] = useState("")
  const [data, setData] = useState({});


const handleChange = (e,name) => {
    setData({
      ...data,
      [name]: e.target.value,
    });
};

const [loadingData, setLoadingData] = useState()
const paymentMethods = async () =>{
  axios.get(urlbase + "/api/cards", settings())
  .then((res) =>{
    if (res.data.code === 200){
      setCard(res.data.data)
      setLoadingData(0)
    }else {
      console.log('Error')
    }
  })
  .catch((error) => {
    console.log(error);
  })
}

const createCheckout = () => {
  setIsProcessing(1)
  const selected = charityPlans.find((plan) => plan.id == choosePlan)
  const yearsQuery = selected?.prepaid_years ? ('?years=' + customYears) : ''
  axios.get(urlbase + "/api/subscriptions/checkout/"+choosePlan+'/'+sessionStorage.getItem('thePlanType')+yearsQuery, settings())
  .then((res) =>{
    if (res.data.code === 200){
      window.location.href = res.data.data.url
    }else {
      console.log('Error')
    }
  })
  .catch((error) => {
    console.log(error);
    setIsProcessing(0)
  })
}

const changeSubscription = () => {
  const selected = charityPlans.find((plan) => plan.id == changePlan)
  if (selected?.prepaid_years) {
    setIsProcessing(1)
    sessionStorage.setItem('thePlanType','old')
    axios.get(urlbase + "/api/subscriptions/checkout/"+changePlan+"/old?years="+customYears, settings())
    .then((res) =>{
      if (res.data.code === 200){
        window.location.href = res.data.data.url
      }else {
        alert(res.data.message || 'Plan could not be changed, please try again later')
        setIsProcessing(0)
      }
    })
    .catch((error) => {
      alert('Something went wrong, please try again later')
      console.log(error);
      setIsProcessing(0)
    })
    return
  }
  setIsProcessing(1)
  axios.get(urlbase + "/api/subscriptions/change/"+changePlan, settings())
  .then((res) =>{
    if (res.data.code === 200){
      sessionStorage.setItem('chgamsSubscription',changePlan);
      alert('Plan changed successfully')
      window.location.reload();
    }else {
      alert('Plan could not be changed, please try again later')
      setIsProcessing(0)
      console.log('Error')
    }
  })
  .catch((error) => {
    alert('Something went wrong, please try again later')
    console.log(error);
    setIsProcessing(0)
  })
}

const [isRenew, setIsRenew] = useState()
const [renewalDue, setRenewalDue] = useState(sessionStorage.getItem('chgamsSubscriptionDue') == 1 ? 1 : 0)
const renewSubscription = () => {
  sessionStorage.setItem('thePlanType','old')
  setChoosePlan(chgamsSubscription)
}

function getQueryParams() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams;
}

const confirmPayment = (session_id,pppp) => {
  axios.get(urlbase + "/api/subscriptions/confirm/"+session_id+'/'+pppp+'/'+sessionStorage.getItem('thePlanType'), settings())
  .then((res) =>{
    if (res.data.code === 200){
      sessionStorage.setItem('chgamsSubscription',res.data.data.sub)
      setchgamsSubscription(res.data.data.sub)
      sessionStorage.removeItem('chgamsSubscriptionDue')
      sessionStorage.removeItem('choose-a-plan')
      if(sessionStorage.getItem('thePlanType') == 'neww'){
        alert('Subscription successful')
      }else{
        alert('Subscription renewal successful')
      }
      window.location.href = res.data.data.url
    }else {
      alert(res.data.message)
    }
    setIsProcessing(0)
  })
  .catch((error) => {
    console.log(error);
    setIsProcessing(0)
  })
}

//alert(chgamsSubscription)

const [subData, setSubData] = useState({})
const [chgamsSubscription, setchgamsSubscription] = useState(sessionStorage.getItem('chgamsSubscription'))
const [chgamsSubscriptionStatus, setchgamsSubscriptionStatus] = useState(0)
const history = async () =>{
  axios.get(urlbase + "/api/billing/history", settings())
  .then((res) =>{
    if (res.data.code === 200){
      const currentSub = res.data.data[1] ? res.data.data[1][0] : null
      setBillingHistory(res.data.data[0] ? res.data.data[0] : [])
      setSubData(currentSub ? currentSub : {})
      setchgamsSubscription(currentSub ? currentSub['plan'] : sessionStorage.setItem('chgamsSubscription'))
      setchgamsSubscriptionStatus(currentSub ? currentSub['status'] : 0)
      if (currentSub && currentSub.renewal_due != null) {
        if (Number(currentSub.renewal_due) === 1 && Number(currentSub.status) !== 0) {
          sessionStorage.setItem('chgamsSubscriptionDue', 1)
          setRenewalDue(1)
        } else {
          sessionStorage.removeItem('chgamsSubscriptionDue')
          setRenewalDue(0)
        }
      }
    }else {
      console.log('Error') 
    }
  })
  .catch((error) => {
    console.log(error);
  })
}
useEffect(() => {
  setLoadingData(1)
  const queryParams = getQueryParams();
  const session_id = queryParams.get('session_id');
  const check = queryParams.get('checkierr');
  if (session_id && check) {
    confirmPayment(session_id,check);
  } 
history()
paymentMethods()
}, [])

const handleClick = async () =>{
  setIsProcessing(1)
  axios
    .get(urlbase + "/api/subscriptions/cancel", settings())
    .then((res) => {
      if (res.data.code === 200) {
        sessionStorage.setItem('chgamsSubscription',0)
        alert(res.data.message)
        window.location.reload();
      } else {
        alert(res.data.message)
        console.log("Error");
      }
      setIsProcessing(0)
    })
    .catch((error) => {
      console.log(error);
      setIsProcessing(0)
    });
}


  const handleSubmit = async (event) => {
    event.preventDefault();
    if(!data.cvv || !data.card_num || !data.expiry_month || !data.expiry_year){
      alert('Please fill all fields')
    } else {
      setIsProcessing(1)
      axios
        .post(urlbase + "/api/cards/create", data, settings())
        .then((res) => {
          if (res.data.code === 200) {
            alert('Card created successfully')
            window.location.reload();
          } else {
            alert(res.data.message)
            console.log("Error");
          }
          setIsProcessing(0)
        })
        .catch((error) => {
          console.log(error)
          alert('Something went wrong, please try again later')
          setIsProcessing(0)
        });
    }
  }

  const [choosePlan, setChoosePlan] = useState()
  const [changePlan, setChangePlan] = useState()
  const [cancelPlan, setCancelPlan] = useState()
  const [charityPlans, setCharityPlans] = useState([])
  const [customYears, setCustomYears] = useState(3)

  useEffect(() => {
    axios.get(urlbase + "/api/plans?context=settings")
      .then((res) => {
        if (res.data.code === 200) {
          setCharityPlans(normalizeCharityPlans(res.data.data))
        }
      })
      .catch(() => {})
  }, [])

  const charityPlanLabel = (id) => {
    const plan = charityPlans.find((item) => item.id == id)
    if (!plan) {
      return null
    }
    return plan.name + ' - ' + plan.formatted_price + '/' + plan.billing_label + (plan.setup_fee_label ? ' ' + plan.setup_fee_label : '')
  }

  const createSubscription = () => {
    sessionStorage.setItem('thePlanType','neww')
    setChoosePlan(1)
  }  

  const agentPlans = [
    {id:4,value:'Silver (1-5 Charities) - £324.99/Yr'},
    {id:5,value:'Silver (6-10 Charities) - £529.99/Yr'},
    {id:6,value:'Silver (11-15 Charities) - £779.99/Yr'},
    {id:1,value:'Gold (1-5 Charities) - £439.99/Yr'},
    {id:2,value:'Gold (6-10 Charities) - £699.99/Yr'},
    {id:3,value:'Gold (11-15 Charities) - £899.99/Yr'},
  ];

  return (
    <>
      {bill ? (
        <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[40%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Add New Payment Method
                </p>
                <button
                  onClick={() => setBill(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="p-8">
                <div className="col-span-2 flex flex-col space-y-2 py-4 mx-auto w-full">
                  <label>Card Number</label>
                  <div className="w-full relative">
                    <input
                      onChange={(e) => handleChange(e,'card_num')}
                      type="text"
                      name="card_num"
                      className="border-[1px] rounded-[4px] w-full h-[50px] px-3 outline-none"
                      placeholder="Enter Card Number"
                    />
                  </div>
                </div>
                <div className="w-full flex justify-between py-4 space-x-2">
                  <div className="col-span-2 flex flex-col space-y-2  mx-auto w-[49%]">
                    <label>Expiration year</label>
                    <div className="w-full">
                      <input
                        onChange={(e) => handleChange(e,'expiry_year')}
                        type="text"
                        name="expiry_date"
                        className="border-[1px] rounded-[4px] w-full h-[50px] px-3 outline-none"
                        placeholder="2023"
                      />
                    </div>
                  </div>
                  <div className="col-span-2 flex flex-col space-y-2 mx-auto w-[49%]">
                    <label>Expiry Month</label>
                    <div className="w-full">
                      <input
                        onChange={(e) => handleChange(e,'expiry_month')}
                        type="text"
                        name="cvv"
                        className="border-[1px] rounded-[4px] w-full h-[50px] px-3 outline-none"
                        placeholder="05"
                      />
                    </div>
                  </div>
                  <div className="col-span-2 flex flex-col space-y-2 mx-auto w-[49%]">
                    <label>CVV</label>
                    <div className="w-full">
                      <input
                        onChange={(e) => handleChange(e,'cvv')}
                        type="text"
                        name="cvv"
                        className="border-[1px] rounded-[4px] w-full h-[50px] px-3 outline-none"
                        placeholder="342"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setBill(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  Cancel
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={handleSubmit}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Add New Card
                </button>
              </div>
              }
            </div>
          </div>
        </div>
      ) : null}

        {choosePlan ? (
          sessionStorage.getItem('agency_id') ?
          <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[50%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3 rounded-[8px]">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Select A plan
                </p>
                <button
                  onClick={() => setChoosePlan(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              {(chgamsSubscription != '1' &&  chgamsSubscription != 0) ? <p className="p-8 pb-0 text-[20px] font-[500]">Continue with your plan or switch</p> : null}
              <div className="p-8">
                <div className="w-full grid grid-cols-4 py-4 gap-x-4 gap-y-2">
                  {agentPlans.map(({id,value}) => {
                      return (
                        <div className="col-span-4 lg:col-span-2 flex flex-col space-y-2 mx-auto w-full">
                                <div className="w-full">
                                  <input
                                    onClick={(e) => setChoosePlan(id)}
                                    type="text"
                                    name="plan"
                                    readOnly
                                    className={`border-[1px] rounded-[4px] w-full h-[50px] px-1 text-center cursor-pointer outline-none ${choosePlan == id ? 'border-[#B30000]' : ''}`}
                                    value={value}
                                  />
                                </div>
                        </div>
                      )
                      })}
                </div>
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setChoosePlan(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  Cancel
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={createCheckout}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Proceed
                </button>
              </div>
              }
            </div>
          </div>
        </div>

          :

          <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[40%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3 rounded-[8px]">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Select A plan
                </p>
                <button
                  onClick={() => setChoosePlan(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              {(chgamsSubscription != '1' &&  chgamsSubscription != 0) ? <p className="p-8 pb-0 text-[20px] font-[500]">Continue with your plan or switch</p> : null}
              <div className="p-8">
                <div className="w-full grid grid-cols-4 py-4 gap-x-4 gap-y-3">
                  {charityPlans.map((plan) => (
                    <div key={plan.id} className="col-span-4 lg:col-span-2 flex flex-col space-y-2 mx-auto w-full">
                      <input
                        onClick={() => setChoosePlan(plan.id)}
                        type="text"
                        name="plan"
                        readOnly
                        className={`border-[1px] rounded-[4px] w-full h-[50px] px-1 text-center cursor-pointer outline-none ${choosePlan == plan.id ? 'border-[#B30000]' : ''}`}
                        value={plan.name + ' - ' + plan.formatted_price + '/' + plan.billing_label}
                      />
                    </div>
                  ))}
                </div>
                {charityPlans.find((plan) => plan.id == choosePlan)?.prepaid_years ? (
                  <div className="flex flex-row space-x-2">
                    {charityPlans.find((plan) => plan.id == choosePlan).prepaid_years.map((year) => (
                      <button
                        key={year}
                        type="button"
                        onClick={() => setCustomYears(year)}
                        className={`border-[1px] rounded-[4px] h-[40px] px-3 ${customYears == year ? 'border-[#B30000] text-[#B30000]' : ''}`}
                      >
                        {year} years
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setChoosePlan(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  Cancel
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={createCheckout}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Proceed
                </button>
              </div>
              }
            </div>
          </div>
        </div>
      ) : null}

{changePlan ? (
      sessionStorage.getItem('agency_id') ? 
        
        <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[40%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3 rounded-[8px]">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Select plan
                </p>
                <button
                  onClick={() => setChangePlan(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              {chgamsSubscription != 1 ? <p className="p-8 pb-0 text-[20px] font-[500]">Choose a new plan</p> : null}
              <div className="p-8">
                <div className="w-full grid grid-cols-4 py-4 gap-x-4 gap-y-4">
                  {agentPlans.map(({id,value}) => {
                    return (
                        <div className="col-span-2 flex flex-col space-y-2 mx-auto w-full">
                          <div className="w-full">
                            <input
                              onClick={(e) => setChangePlan(id)}
                              type="text"
                              name="plan"
                              readOnly
                              className={`border-[1px] rounded-[4px] w-full h-[50px] px-1 text-center cursor-pointer outline-none ${chgamsSubscription == id ? 'border-[#B30000]' : ''}`}
                              value={value}
                            />
                          </div>
                        </div>
                    )
                  })}
                </div>
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setChangePlan(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  Cancel
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={changeSubscription}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Proceed
                </button>
              </div>
              }
            </div>
          </div>
        </div>

        :
        <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[40%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3 rounded-[8px]">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Select plan
                </p>
                <button
                  onClick={() => setChangePlan(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              {chgamsSubscription != 1 ? <p className="p-8 pb-0 text-[20px] font-[500]">Choose a new plan</p> : null}
              <div className="p-8">
                <div className="w-full grid grid-cols-4 py-4 gap-x-4 gap-y-4">
                  {charityPlans.filter((plan) => plan.id != chgamsSubscription).map((plan) => (
                    <div key={plan.id} className="col-span-4 lg:col-span-2 flex flex-col space-y-2 mx-auto w-full">
                      <input
                        onClick={() => setChangePlan(plan.id)}
                        type="text"
                        name="plan"
                        readOnly
                        className={`border-[1px] rounded-[4px] w-full h-[50px] px-1 text-center cursor-pointer outline-none ${changePlan == plan.id ? 'border-[#B30000]' : ''}`}
                        value={plan.name + ' - ' + plan.formatted_price + '/' + plan.billing_label}
                      />
                    </div>
                  ))}
                </div>
                {charityPlans.find((plan) => plan.id == changePlan)?.prepaid_years ? (
                  <div className="flex flex-row space-x-2">
                    {charityPlans.find((plan) => plan.id == changePlan).prepaid_years.map((year) => (
                      <button
                        key={year}
                        type="button"
                        onClick={() => setCustomYears(year)}
                        className={`border-[1px] rounded-[4px] h-[40px] px-3 ${customYears == year ? 'border-[#B30000] text-[#B30000]' : ''}`}
                      >
                        {year} years
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setChangePlan(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  Cancel
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={changeSubscription}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Proceed
                </button>
              </div>
              }
            </div>
          </div>
        </div>
        
      ) : null}

        {cancelPlan ? (
        <div
          id="defaultModal"
          tabIndex="-1"
          aria-hidden="true"
          className={`fixed bg-[rgba(65,_66,_88,_0.62)] rounded-[10px] top-0 bottom-0 left-0 z-[1000] w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative w-[95%] lg:w-[40%] mt-[25%] lg:mt-[10%] max-h-full mx-auto text-[#333]">
            <div className="relative bg-white shadow pt-3">
              <div className="flex items-start justify-between border-b-[1px] px-8 pb-3">
                <p className="text-[#121927] text-[20px] font-[600]">
                  Cancel Subscription
                </p>
                <button
                  onClick={() => setCancelPlan(0)}
                  type="button"
                  className="text-gray-300 font-[200] bg-transparent hover:bg-[#F2F2F2] hover:text-black rounded-full p-1.5 ml-auto inline-flex items-center"
                  data-modal-hide="defaultModal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="p-8">
                <div className="w-full flex justify-between py-4 space-x-2 text-[18px]">
                  Are you sure you want to cancel your subscription ?
                </div>
              </div>
              {isProcessing ? <div>Please wait...</div> : 
              <div className="flex flex-row justify-end mt-5 space-x-2 px-8 bg-[#F7F7F7] rounded-b-[10px] py-4">
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={() => setCancelPlan(0)}
                  className="border-[1px] border-[#828282] text-[#121927] w-[102px] h-[50px] rounded-[8px] bg-white"
                >
                  No
                </button>
                <button
                  data-modal-hide="defaultModal"
                  type="button"
                  onClick={handleClick}
                  className={`border-[1px] w-[150px] h-[50px] bg-[#B30000] rounded-[8px] border-none text-white`}
                >
                  Yes
                </button>
              </div>
              }
            </div>
          </div>
        </div>
      ) : null}

      
      {!loadingData ?
      <>
      <div className="border-b-[1px] pb-7 text-[#4F4F4F] md:flex md:flex-row md:justify-between md:items-center">
        <div className="flex flex-col space-y-2">
          <p className="text-[20px] font-[600] text-[#121927]">Manage Subscriptions</p>
          <p className="text-[#4F4F4F] font-[400] text-[16px]">
            Here you can view your subscription plan, cancel or view your recent billings.
          </p>
          {chgamsSubscription == 1 ? <p className="text-[#b30000]">Our system will remove all trial data (members & donations) when you start a paid subscription.</p> : null }
        </div>
        {isProcessing ? <span className="text-[#B30000]">Please wait..</span>:
        <div className="pt-4">
          {(chgamsSubscription == 1 || (chgamsSubscription != 1 &&  chgamsSubscription != 0)) && chgamsSubscriptionStatus != 0 ?
          <button className="bg-[#FFF] py-2 px-4 text-[#121927] font-[600] rounded-[4px] border border-[#EAEAEA]" onClick={() => setCancelPlan(1)}>
            Cancel Subscription
          </button>
          : sessionStorage.getItem('chgamsSubscriptionDue') != 1 || chgamsSubscriptionStatus == 0 ?
          <button className="bg-[#FFF] py-2 px-4 text-[#121927] font-[600] rounded-[4px] border border-[#EAEAEA]" onClick={() => createSubscription()}>
            Create Subscription
          </button> : null
          }
        </div>}
      </div>
      <div className="lg:flex lg:flex-row md:justify-between md:items-center lg:items-start border-b-[1px] pb-7 text-[#4F4F4F]">
        <div className="flex flex-col space-y-2 pb-4 lg:flex-1">
          <p className="text-[20px] font-[600] text-[#121927]">
            Your Plan
          </p>
          {sessionStorage.getItem('agency_id') ? 
            <p className="text-[#4F4F4F] font-[400] text-[16px]">
              Your Current agency plan is : <span className="font-[600]">{(chgamsSubscription == 0 || sessionStorage.getItem('choose-a-plan') == 1 ) ? 'No subscription' : ((
                chgamsSubscription == 4 ? 'Silver (1-5 Charities) - £324.99/Yr' : 
                chgamsSubscription == 5 ? 'Silver (6-10 Charities) - £529.99/Yr' : 
                chgamsSubscription == 6 ? 'Silver (11-15 Charities) - £779.99/Yr': 
                chgamsSubscription == 1 ? 'Gold (1-5 Charities) - £439.99/Yr' :
                chgamsSubscription == 2 ? 'Gold (6-10 Charities) - £699.99/Yr' : 
                'Gold (11-15 Charities) - £899.99')+ (subData.due_date ? (' due on ' + subData.due_date) : ''))}</span>
            </p>:

            <p className="text-[#4F4F4F] font-[400] text-[16px]">
              Your Current Plan is : <span className="font-[600]">{(chgamsSubscription == 0 || sessionStorage.getItem('choose-a-plan') == 1 || subData.status == 0) ? 'No subscription' : ((charityPlanLabel(chgamsSubscription) || 'Plan ' + chgamsSubscription) + (subData.due_date ? (' due on ' + subData.due_date) : ''))}</span>
            </p>
        }
          
          {chgamsSubscription > 0 && chgamsSubscriptionStatus != 0 ? 
              <p onClick={() => setChangePlan(1)} className="text-[#B30000] cursor-pointer font-[400] text-[16px]">
              Change your plan
            </p> : null
          }

        </div>
        <div>
        {renewalDue == 1 ?
          <button className="bg-[#FFF] py-2 px-4 text-[#B30000] font-[600] rounded-[4px] border border-[#B30000]" onClick={renewSubscription}>
            Renew Subscription
          </button>
          : null
          }
        </div>
      </div>
      <div className="lg:flex lg:flex-row lg:justify-between lg:items-center  text-[#4F4F4F]">
        <div className="">
          <p className="text-[20px] font-[600] text-[#121927]">
            Billing History
          </p>
        </div>
      </div>
      {billingHistory.length > 0 ?
      <div className="pb-10">
        <div className="w-full overflow-x-auto border-[1px] rounded-[8px]">
          <table className="w-full">
            <thead className="bg-[#F7F7F7] w-full rounded-[8px]">
              <tr className="text-[#292D32] font-[400]">
                {/* <th className="px-9 py-3 text-start">
                  <input type="checkbox" />
                </th> */}
                <th className="px-9 py-3 text-start">Plan</th>
                <th className="px-9 py-3 text-start">Renewal/Subcription Date</th>
                <th className="px-9 py-3 text-start">Amount(£)</th>
                <th className="px-9 py-3 text-start">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {billingHistory.map((item, index) => (
                <tr className="mt-3" key={index}>
                  {/* <td className="px-9 py-3 text-start text-[#4F4F4F]">
                    <input type="checkbox" />
                  </td> */}
                  <td className="px-9 py-3 text-start text-[#4F4F4F]">
                    {charityPlanLabel(item.plan) || (item.plan == 1 ? 'Starter' : 'Plan ' + item.plan)}
                  </td>
                  <td className="px-9 py-3 text-start text-[#4F4F4F]">
                    {format(new Date(item.created_at),'yyyy-MM-dd')}
                  </td>
                  <td className="px-9 py-3 text-start text-[#4F4F4F]">
                    {item.amount_display || item.amount}
                  </td>
                  <td className={`px-9 py-3 text-start text-[#4F4F4F] w-[41px] rounded-[30px] h-[17px]`}>
                    <span className={`${item.status == 0 ? 'bg-[#B30000] text-[#F4F2F2]' : 'bg-[#E9F0EC] text-[#219653]'} p-2 rounded-[30px]`}>{item.status == 0 ? 'Failed' : (item.status == 1 ? 'Subscribed' : 'Renewed')}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      : 'No billing history'}
    </> : <div className="text-center my-auto">Please wait ...</div>}
    </>
  );
}

export default Billings;
